import React from 'react';
import PropTypes from 'prop-types';

import JobsUserContainer from './JobsUserContainer';
import FlatJobsContainer from './FlatJobsContainer';


const FlatJobsContainerWrapper = ({ isSubaccountDashboard, ...props }) => (
  <JobsUserContainer {...props}>
    <FlatJobsContainer isSubaccountDashboard={isSubaccountDashboard} />
  </JobsUserContainer>
);

FlatJobsContainerWrapper.defaultProps = {
  isSubaccountDashboard: false,
};
FlatJobsContainerWrapper.propTypes = {
  isSubaccountDashboard: PropTypes.bool,
};

export default FlatJobsContainerWrapper;
